import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GenerateContents } from "../../redux/slice/genrateai/GenerateContentSlice.js";
import './GenerateAi.css';
// import { Link } from "react-router-dom";

const GenerateContent = () => {
  const [prompt, setPrompt] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status
  const dispatch = useDispatch();
  const { content, loading, error } = useSelector((state) => state.GenerateContent || {});

  // Check if the user is logged in on component mount
  useEffect(() => {
    const userToken = true; 
    if (userToken) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false); 
    }
  }, []);

  const handleGenerateContents = () => {
    if (prompt.trim()) {
      dispatch(GenerateContents(prompt));
    }
  };

  const formatContent = (content) => {
    const cleanContent = content
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/\bhtml\b/g, "")
      .replace(/```/g, "")
      .trim();
    return cleanContent.split("\n").map((line, index) => (
      <p key={index} style={{ fontSize: "1rem", lineHeight: "1.6" }}>
        {line}
      </p>
    ));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGenerateContents();
    }
  };

  const handleCopyToClipboard = () => {
    if (content) {
      navigator.clipboard.writeText(content)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 5000);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  // If the user is not logged in, show the login prompt
  if (!isLoggedIn) {
    return (
      <div className="text-center ">
        <div className="alert alert-warning background-dark p-5" role="alert">
          <h4 className="alert-heading landing-text-white">You need to log in!</h4>
          <p className="landing-text-white"> Please log in to view your Generate Content Dashboard.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary m-2" onClick={() => window.location.href = "/dashboard"}>
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <h3 className="text-center mb-5">Generate Content</h3>
      <div className="row g-4 justify-content-center">
        <div className="col-md-6 col-lg-5 d-flex justify-content-center align-items-center bg-gradient-info py-4 rounded-lg shadow-lg border w-100">
          <div className="text-center w-50 mt-2">
            <h5 className="text-primary mb-4 mt-3">Generate AI Content</h5>
            <input
              type="text"
              className="form-control mb-4 mt-5 p-3 fs-5 rounded-3"
              placeholder="Enter a prompt"
              value={prompt}
              onKeyPress={handleKeyPress}
              onChange={(e) => setPrompt(e.target.value)}
            />
            <button
              className="btn btn-warning w-100 mt-2 mb-5 p-3 rounded-3"
              onClick={handleGenerateContents}
            >
              Generate Content
            </button>
          </div>
        </div>
        <div className="col-md-5 ms-sm-3 ms-0 col-lg-5 bg-gradient-info py-4 rounded-lg shadow-lg border w-100">

          <div>
            {loading ? (
              <div className="spinner"></div>
            ) : error ? (
              <div>Error: {error}</div>
            ) : (
              content ? (
                <div className="p-4  bg-light text-dark fw-bolder rounded shadow-sm">
                  {formatContent(content)}
                </div>
              ) : (
                <div>
                  <h5 className="text-center text-primary mb-4">Output</h5>
                </div>
              )
            )}
          </div>
          {content && (
            <div className="copy-button text-end mt-3">
              <button
                onClick={handleCopyToClipboard}
                className={`btn rounded-3 justify-content-right ${isCopied ? 'btn-success' : 'btn-primary'}`}
              >
                {isCopied ? (
                  <i className="bi bi-check-circle-fill"></i>
                ) : (
                  <i className="bi bi-clipboard-check"></i>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenerateContent;
